import axios from 'axios';
import PathManagement from '../common/path-management';
import { getResponseByUrl, postResponseByUrl } from '../common/xhr';

export default class NotificationsView {

    notificationsData!: NotificationsData;
    readNotificationsData!: ReadNotificationsData
    read1NotificationData!: Read1NotificationData
    allNotificationsData!: AllNotificationsData

    async getNotifications(): Promise<NotificationsData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getNotifications();
        try {
            this.notificationsData = await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de la portada');
        }

        return this.notificationsData;
    }

    async readNotifications(array): Promise<ReadNotificationsData>{
        let _pathManager = new PathManagement();
        let url = _pathManager.getReadNotificationsUrl();
        try{
            // response = await axios.post(url,{idList: array},  { withCredentials: true });
            // this.readNotificationsData = response.data

            let dataToPost = {idList: array};
            this.readNotificationsData = await postResponseByUrl(url, dataToPost)

        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de las notificaciones');
        }

        return this.readNotificationsData;
    }

    async read1Notification(id): Promise<Read1NotificationData>{
        let _pathManager = new PathManagement();
        let url = _pathManager.getRead1Notification(id);
        try{
            // response = await axios.post(
            //     url, {id: id}, { withCredentials: true });
            // this.read1NotificationData = response.data


            let dataToPost = {id: id};
            this.read1NotificationData = await postResponseByUrl(url, dataToPost)
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de las notificaciones');
        }

        return this.read1NotificationData;
    }

    async getAllNotifications(): Promise<AllNotificationsData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getAllNotifications();
        try {
            this.allNotificationsData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de la portada');
        }

        return this.allNotificationsData;
    }

    async readAllNotifications(): Promise<AllNotificationsData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getReadAllNotifications();
        try {
            this.allNotificationsData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de la portada');
        }

        return this.allNotificationsData;
    }

    }




export interface Read1NotificationData{
    read1NotificationData:any
}

export interface NotificationsData {
    notificationsData: any
}

export interface ReadNotificationsData{
    readNotificationsData: any
}

export interface AllNotificationsData{
    allNotificationsData: any
}